import { getMentionsPlugin as deprecated } from '../suggestion/MentionsPlugin';

/**
 * @deprecated use alternative import instead
 * ```js
 * import { createSuggestionPlugin } from 'hubspot-prosemirror/prosemirror/plugins/suggestion'
 * ```
 */
export const getMentionsPlugin = deprecated;